module.exports = __webpack_public_path__ + "static/media/logo.d0f99284.svg";